const AlignCenter = () => {
  return (
    <svg
      width="95"
      height="95"
      viewBox="0 0 95 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.226562"
        width="94.6072"
        height="94.6072"
        rx="47.3036"
        transform="rotate(0.0638669 0.226562 0)"
      />
      <g clipPath="url(#clip0_127_3268)">
        <path
          d="M46.5383 19.7599C55.6329 19.7599 64.7282 19.7599 73.8241 19.7599C75.9109 19.7599 77.2231 21.1448 77.0624 23.1513C77.013 23.7746 76.7642 24.3654 76.3529 24.8364C75.9416 25.3073 75.3895 25.6333 74.7785 25.7661C74.3332 25.8474 73.8808 25.884 73.4281 25.8751C55.5016 25.8751 37.5744 25.8751 19.6466 25.8751C19.0995 25.8899 18.5532 25.8254 18.0245 25.6838C16.6244 25.2592 15.8516 23.926 16.0238 22.3651C16.1103 21.6844 16.4292 21.0543 16.9265 20.5814C17.4238 20.1085 18.069 19.8217 18.7533 19.7695C19.0134 19.7485 19.2774 19.758 19.5414 19.758L46.5383 19.7599Z"
          fill="black"
        />
        <path
          d="M46.501 58.4409C37.4077 58.4409 28.3131 58.4409 19.2172 58.4409C17.1131 58.4409 15.801 56.9949 16.0248 54.952C16.0987 54.3192 16.3779 53.728 16.8197 53.2689C17.2616 52.8098 17.8416 52.5081 18.4712 52.4099C18.8984 52.3598 19.3285 52.3394 19.7585 52.3487C37.6111 52.3487 55.4637 52.3487 73.3163 52.3487C73.864 52.326 74.4124 52.3742 74.9478 52.4922C76.4149 52.8881 77.2432 54.273 77.0519 55.8797C76.9643 56.5871 76.62 57.2377 76.0844 57.7081C75.5488 58.1785 74.8592 58.4358 74.1464 58.4314C70.3495 58.4524 66.5546 58.4314 62.7596 58.4314L46.501 58.4409Z"
          fill="black"
        />
        <path
          d="M46.4959 74.7478C40.4324 74.7478 34.3689 74.7478 28.3054 74.7478C26.033 74.7478 24.5774 72.7107 25.3349 70.6258C25.495 70.1342 25.7878 69.6965 26.1811 69.361C26.5743 69.0255 27.0527 68.8052 27.5633 68.7244C27.9626 68.6571 28.3673 68.627 28.7721 68.6345C40.6122 68.6345 52.4523 68.6345 64.2924 68.6345C64.8395 68.6208 65.3857 68.6891 65.9125 68.8373C67.3337 69.2868 68.1046 70.685 67.8693 72.2478C67.7587 72.9251 67.4166 73.543 66.9015 73.9964C66.3864 74.4498 65.73 74.7106 65.0441 74.7344C64.1375 74.7707 63.2289 74.744 62.3222 74.744L46.4959 74.7478Z"
          fill="black"
        />
        <path
          d="M46.5681 36.0658C52.6316 36.0658 58.6944 36.0658 64.7566 36.0658C66.8014 36.0658 68.104 37.5367 67.8821 39.549C67.8071 40.1816 67.5275 40.7724 67.0859 41.2316C66.6443 41.6908 66.0649 41.9932 65.4357 42.093C65.0334 42.142 64.6282 42.1625 64.223 42.1542C52.4314 42.1542 40.6391 42.1542 28.8462 42.1542C28.3225 42.173 27.7987 42.1248 27.2873 42.0107C25.7972 41.6033 24.9575 40.1687 25.1966 38.5524C25.407 37.1217 26.6254 36.0658 28.1633 36.0658C34.2995 36.0581 40.4344 36.0581 46.5681 36.0658Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_3268">
          <rect width="61.0807" height="55" transform="translate(16 19.7578)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlignCenter;
